export const getUserBasePath = (userId) => `users/${userId}`;

export const getListBasePath = (userId, listId) =>
  `${getUserBasePath(userId)}/todoLists/${listId}`;

export const getProblemAttemptsCollectionPath = (userId, listId) =>
  `${getListBasePath(userId, listId)}/problemAttempts`;

export const getTelemetryEventsCollectionPath = (userId, listId) =>
  `${getListBasePath(userId, listId)}/telemetryEvents`;

export const getFlashcardsCollectionPath = (userId) =>
  `${getUserBasePath(userId)}/flashcards`;
